import { Box, Grid, List, Toolbar, Typography } from '@mui/material'
import { Path } from '../../types/Path'
import { ItemColorProps, SidebarListItem } from './SidebarListItem'
import { SettingsSidebarItem } from '../Settings/SettingsSidebarItem'
import { AdminSidebarItem } from '../Settings/AdminSidebarItem'
import { useContext } from 'react'
import { ProfileContext } from '../../contexts/ProfileContext'

export interface SidebarContentProps {
  title?: string
  listItems?: Path[]
  basePath?: string
  colors?: ItemColorProps
}

export function SidebarContent({
  title,
  listItems,
  basePath,
  colors,
}: SidebarContentProps) {
  const { userName, userRole } = useContext(ProfileContext)
  const isAdmin = userRole === 'admin' || userRole === 'super_admin'

  return (
    <Box
      sx={{
        px: '1rem',
        pt: '2rem',
        height: '100%',
      }}
    >
      <Grid container direction='column' wrap='nowrap' sx={{ height: '100%' }}>
        {title && (
          <Grid item>
            <Box sx={{ mx: '0.5rem' }}>
              <Toolbar disableGutters>
                <Typography fontSize='1.25rem' fontWeight={700}>
                  {title}
                </Typography>
              </Toolbar>
            </Box>
          </Grid>
        )}
        <Grid item flexGrow={1}>
          <List sx={{ py: '0.5rem' }}>
            {listItems &&
              listItems.map((item) => (
                <SidebarListItem
                  key={item.label}
                  title={item.label}
                  icon={item.icon}
                  to={item.to}
                  basePath={basePath}
                  colors={colors}
                />
              ))}
          </List>
        </Grid>
        <Grid item>
          <List sx={{ py: '0.5rem' }}>
            <Typography
              sx={{
                px: '1rem',
                pb: '0.5rem',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                whiteSpace: 'normal',
              }}
              variant='body1'
            >
              {userName}
            </Typography>
            {isAdmin && <AdminSidebarItem />}
            <SettingsSidebarItem />
            <SidebarListItem
              key={'Útskrá'}
              title={'Útskrá'}
              icon={'logout'}
              to={'utskra'}
              colors={colors}
            />
          </List>
        </Grid>
      </Grid>
    </Box>
  )
}
